import React from 'react';
import HighlightText from '@adsk/alloy-react-highlight-text';
import theme from '@adsk/alloy-react-theme';
const HighlightedItemText = _ref => {
  let {
    text,
    search,
    highlighted
  } = _ref;
  return /*#__PURE__*/React.createElement(HighlightText, {
    text: text,
    matched: search,
    highlightStyle: highlighted ? {
      backgroundColor: theme.colors.adskBlue100,
      color: theme.colors.black
    } : undefined
  });
};
HighlightedItemText.displayName = 'HighlightedItemText';
export default HighlightedItemText;
//# sourceMappingURL=HighlightedItemText.js.map